import * as React from 'react';
import Layout from '../components/layout';
import { Link, graphql } from 'gatsby';

export const query = graphql`
    query {
		allMarkdownRemark {
			totalCount
			edges {
				node {
					id
					frontmatter {
						title
						date(formatString: "DD MMMM, YYYY")
					}
					fields {
						slug
					}
					excerpt
				}
			}
		}
    }
`;

export default class Blog extends React.Component<{data: any}, {}> {

    public render() {
        const component =
			<Layout>
				<div>
					{this.props.data.allMarkdownRemark.edges.map(({ node }) => (
						<div key={node.id}>
							<Link to={node.fields.slug}>
							<h3>
								{node.frontmatter.title}{' '}
								<span>— {node.frontmatter.date}	</span>
							</h3>
							<p>{node.excerpt}</p>
							</Link>
						</div>
					))}
				</div>
			</Layout>;

        return component;
    }
}
